import { Pipe, PipeTransform } from '@angular/core';
import { USER_ROLE } from 'src/app/core/constants/user-role.enum';
import { Role } from 'src/app/core/models/role.model';

const AVAILABLE = 'AVAILABLE';
const DEACTIVATED = 'DEACTIVATED';

@Pipe({
    name: 'handleCardItemsListStatusAndRole'
})
export class HandleCardItemsListStatusAndRole implements PipeTransform {
    transform(list: any[]): any[] {
        if (list) {
            return list.map(item => ({
                ...item,
                statusBool: isAvailable(item.status),
                statusText: getStatusTxt(item.status),
                statusTextTicket: getStatusTxtTicket(item.isActive || item.active),
                isAccountManager: isAccountManager(item.roles),
                accountManagerText: getAccountManagerTxt(item.roles),
                statusBoolEnable: isEnable(item.status),
                statusEnableText: getStatusTxtActivate(item.status),
                isShiftManager: isShiftManager(item.roles),
                shiftManagerText: getShiftManagerTxt(item.roles)
            }));
        }
        return [];
    }
}

export function isAccountManager(roles: Role[]): boolean {
    if (!roles) return false;
    return roles.some(role => role.name === USER_ROLE.ACCOUNT_MANAGER);
}
export function isShiftManager(roles: Role[]): boolean {
    if (!roles) return false;
    return roles.some(role => role.name === USER_ROLE.SHIFT_MANAGER);
}

export function isAvailable(status: string): boolean {
    return status === AVAILABLE;
}
export function isEnable(status: string): boolean {
    return status !== DEACTIVATED;
}
export function getStatusTxtTicket(status: boolean): string {
    return status ? 'active' : 'notActive';
}
export function getStatusTxt(status: string): string {
    return isAvailable(status) ? 'active' : 'notActive';
}
export function getStatusTxtBO(status: boolean): string {
    return status ? 'active' : 'notActive'; //? undefined :'notActive';
}
export function getStatusTxtActivate(status: string): string {
    return isEnable(status) ? 'enabled' : 'notEnabled';
}
export function getAccountManagerTxt(roles: Role[]): string {
    return isAccountManager(roles) ? 'securityCoordinatorUser' : '';
}
export function getShiftManagerTxt(roles: Role[]): string {
    return isShiftManager(roles) ? 'shiftManager' : '';
}
